import { VOICE_REVENUE_TRANSACTION_STATUS } from './voiceCloning';

const TAX_THRESHOLD = 5000000;
const TAX_RATE = {
  DEFAULT: 0,
  HIGH: 0.1,
};
const MINIMUM_VOICE_REVENUE_WITHDRAWAL_AMOUNT = 2000000;
// Conversion rate shown in the earnings tooltip: characters ↔ revenue.
const VOICE_REVENUE_RATE_CHARACTERS = 1000000;
const VOICE_REVENUE_RATE_AMOUNT = 20000;
const MAX_SIZE_IDENTITY_UPLOAD = 1024 * 1024 * 5;

const STEP_WITHDRAWAL_STATUS = [
  {
    label: 'pendingV2',
    value: [
      VOICE_REVENUE_TRANSACTION_STATUS.PENDING,
      VOICE_REVENUE_TRANSACTION_STATUS.INIT,
    ],
  },
  {
    label: 'process',
    value: [VOICE_REVENUE_TRANSACTION_STATUS.PROCESSING],
  },
  {
    label: 'paid',
    value: [VOICE_REVENUE_TRANSACTION_STATUS.PAID],
  },
];

const WITHDRAWAL_REQUEST_SORT = {
  CREATED_AT_ASC: 'createdAt_asc',
  CREATED_AT_DESC: 'createdAt_desc',
};

const VOICE_REVENUE_TRANSACTION_IN_VALID = 9003;

const WITHDRAWAL_SOURCE = {
  VOICE_REVENUE: 'voice-revenue',
  AFFILIATE: 'affiliate',
};

export {
  TAX_THRESHOLD,
  TAX_RATE,
  MINIMUM_VOICE_REVENUE_WITHDRAWAL_AMOUNT,
  VOICE_REVENUE_RATE_CHARACTERS,
  VOICE_REVENUE_RATE_AMOUNT,
  MAX_SIZE_IDENTITY_UPLOAD,
  STEP_WITHDRAWAL_STATUS,
  WITHDRAWAL_REQUEST_SORT,
  VOICE_REVENUE_TRANSACTION_IN_VALID,
  WITHDRAWAL_SOURCE,
};
